module.exports = __webpack_public_path__ + "img/jameson-form-bg-mobile-left.535343a9.png";